module.exports = {"name":"nodes","values":[]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/data/inputs/nodes.json
// module id = /Ech
// module chunks = 0